module.exports = __webpack_public_path__ + "static/hub-teal-9e78fc6638c22c2d46a5f08b30c61e6d.png";